import {NavItem} from '@albert-io/atomic';
import React from 'react';
import {Link} from 'react-router';

import AssignmentsFoldersDropdown from '../AssignmentsFoldersDropdown.react';
import useNavItems from '../useNavItems';

const MainNavItems = () => {
  const {pathname} = window.location;
  const {getIsMatchingRoute, mainNavItems} = useNavItems();

  return (
    <nav className='global-nav__main' aria-label='main'>
      <ul className='global-nav__main-list'>
        {mainNavItems.map((navItem) => {
          const {hardLink = false, key, name, route} = navItem;

          const isMatchingRoute = getIsMatchingRoute(navItem);
          const props = {
            [hardLink ? 'href' : 'to']: route
          };
          const LinkElement = hardLink ? 'a' : Link;

          if (key === 'assignments') {
            return (
              // @ts-ignore
              <AssignmentsFoldersDropdown
                key={key}
                isMatchingRoute={isMatchingRoute}
                navItem={navItem}
                pathname={pathname}
                {...props}
              />
            );
          }

          return (
            <li key={key}>
              {/* @ts-ignore */}
              <NavItem {...props} as={LinkElement} active={isMatchingRoute}>
                {name}
              </NavItem>
            </li>
          );
        })}
      </ul>
    </nav>
  );
};

export default MainNavItems;
